import axios from 'axios'
import { getAuthToken } from './TokenUtility'

/* Journal d'activité des administrateurs (admin-service, POST /journal/activite) :
   pages ouvertes et exports lancés. Les connexions sont notées par le serveur.

   LE JOURNAL NE BLOQUE JAMAIS L'ACTION. Client axios dédié, volontairement
   hors des intercepteurs de session : un refus du journal ne doit ni
   déconnecter l'admin ni interrompre un export. L'échec est écrit en console,
   rien n'est affiché.

   AUCUN CONTENU SENSIBLE : la cible est un chemin sans paramètres ni ancre
   (les filtres, recherches et emails y vivent), ou le nom d'un export. Le
   serveur nettoie de nouveau ; on n'envoie déjà pas ce qu'il n'a pas à voir. */

export type TypeActivite = 'page' | 'export'

/** Longueur maximale d'une cible, alignée sur le serveur. */
export const CIBLE_MAX = 120

const client = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? 'https://dev-admin.tribe.sn' : '',
  timeout: 5000,
})

/** Cible sûre : sans « ? », « # » ni « ; » et ce qui suit, emails masqués, longueur bornée. */
export function cibleSure(brute: string): string {
  let c = (brute ?? '').trim()
  const coupure = c.search(/[?#;]/)
  if (coupure >= 0) c = c.slice(0, coupure)
  c = c.replace(/[^\s/@]+@[^\s/@]+/g, '[email]')
  return c.slice(0, CIBLE_MAX)
}

export async function noterActivite(type: TypeActivite, cible: string): Promise<void> {
  try {
    const token = getAuthToken()
    const propre = cibleSure(cible)
    if (!token || !propre) return
    await client.post('/journal/activite', { type, cible: propre }, {
      headers: { Authorization: `Bearer ${token}` },
    })
  } catch (e: any) {
    console.error('[journal] activité non notée :', type, e?.response?.status ?? e?.message ?? e)
  }
}

/** Noms des exports, stables : c'est ce qu'on lira dans le journal. */
export const EXPORTS = {
  lieuxCsv: 'lieux-csv',
  retraitsCsv: 'retraits-file-csv',
  queteCsv: 'quete-soumissions-csv',
  queteRapportPdf: 'quete-rapport-pdf',
  exportCibleCsv: 'export-donnees-csv',
  exportCibleGeojson: 'export-donnees-geojson',
  exportRapportPdf: 'export-donnees-rapport-pdf',
} as const
